export default "__VITE_ASSET__BFsl$lwd__"